import { isV2ApiError } from '../../services/v2/errors';

/**
 * What to tell the client when changing the password failed. The server
 * answers with a code; the screen used to look for "invalid", "credentials"
 * or "password" anywhere in the text, so almost any failure — a refusal under
 * impersonation, a server error — read "Current password is incorrect".
 */
export const changePasswordErrorMessage = (err: unknown): string => {
  if (isV2ApiError(err)) {
    if (err.code === 'invalid_credentials') {
      return 'Current password is incorrect';
    }
    // validation_error, impersonation_forbidden, server errors: the server's
    // own words say what went wrong. (This endpoint does not answer
    // weak_password; the length rule is checked on the screen first.)
    return err.message || 'Failed to change password';
  }
  return err instanceof Error && err.message ? err.message : 'Failed to change password';
};
